export var PaimonRestAuthMode;
(function (PaimonRestAuthMode) {
    PaimonRestAuthMode["PAIMON_REST_AUTH_MODE_OAUTH2"] = "oauth2";
    PaimonRestAuthMode["PAIMON_REST_AUTH_MODE_BEARER"] = "bearer";
    PaimonRestAuthMode["PAIMON_REST_AUTH_MODE_HEADER"] = "header";
    PaimonRestAuthMode["PAIMON_REST_AUTH_MODE_SIGV4"] = "sigv4";
    PaimonRestAuthMode["PAIMON_REST_AUTH_MODE_NONE"] = "none";
})(PaimonRestAuthMode || (PaimonRestAuthMode = {}));
